export default __webpack_public_path__ + "static/media/location.1865408a.svg";